import { connect } from 'react-redux';
import { getAvailableAddons } from '../redux/actions/dinings';
import Dining from '../components/dining/Dining';
import { saveAddon } from '../redux/actions/changeAddon';
import { swimmingPage, dinnerType, shouldFetchDining, getShouldSkipDiningPage } from '../utils';

const mapStateToProps = ({ dinings, bookingSearch, config }) => ({
  diningSlots: dinings.diningSlots,
  title: 'Setup your experience',
  subTitle: 'Dinner time?',
  separatorLabel: 'Dining room closed for deep clean',
  type: dinnerType,
  resId: bookingSearch.resId,
  redirectPath: swimmingPage,
  bookedAddon: dinings.bookedDinner,
  shouldFetchAvailableAddons: shouldFetchDining(dinings, bookingSearch, config),
  shouldSkip: getShouldSkipDiningPage(dinings, bookingSearch, dinnerType, config),
  optionsTitle: 'Choose evening meal time',
  refreshTimeInterval: parseInt(config.REACT_APP_REFRESH_TIME_INTERVAL, 10) || 15,
  lastConfigCheckDateTime: config.lastConfigCheckDateTime,
});

const mapDispatchToProps = dispatch => ({
  getAvailableAddons: resId => dispatch(getAvailableAddons(resId)),
  saveAddon: (resId, addonCode, action, isEditBooking) => dispatch(saveAddon(resId, addonCode, action, isEditBooking)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dining);
